// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"868":"b2da6c8c","971":"61667052"}[chunkId] + ".css";
};